import React from 'react';
import { Button } from '@innovyze/stylovyze';
import { MenuGrid } from './CreateValuemappingProfile.styles';
import { useGlobalization } from '@Translations/useGlobalization';

interface ControlButtonsProps {
	onClickCancelButton(): void;
	onClickSaveButton(): void;
	saveDisabled: boolean;
}

const ControlsButtons: React.FC<ControlButtonsProps> = (
	props: ControlButtonsProps,
) => {
	const {
		onClickCancelButton,
		onClickSaveButton,
		saveDisabled,
	}: ControlButtonsProps = props;
	const { t } = useGlobalization();

	return (
		<MenuGrid>
			<Button
				variant="contained"
				onClick={onClickCancelButton}
				data-cy="cancel-action-button">
				{t('Cancel')}
			</Button>
			<Button
				variant="contained"
				onClick={onClickSaveButton}
				color="primary"
				data-cy="save-action-button"
				disabled={saveDisabled}>
				{t('Save')}
			</Button>
		</MenuGrid>
	);
};

export default ControlsButtons;
